export default __webpack_public_path__ + "static/media/carta_seleciona_02.07d9191b.mp3";